import React, { useEffect, useState } from "react";
import {
  updateFormContentPreview,
  getFormContentPreview,
  imageUploadClientPreview,
} from "../../../../api/services/services";
import { Grid, Button, Snackbar } from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import { Bucket } from "../../../../api/config/apiConfig";
import ContactDetailField from "../../../molecules/ContactDetailField";
import Input from "../../../atoms/Input";
import DynamicText from "../../../molecules/DynamicText";
import generatePDF, { Resolution, Margin } from "react-to-pdf";
import html2pdf from "html2pdf.js";
import { useLocation } from "react-router-dom";
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";

const DeliveryReceiptDownload = ({ formContent, surveyData }) => {
  const [formContentId, setFormContentId] = useState("");

  const [isEdit, setIsEdit] = useState(false);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const location = useLocation();
  const urlData = new URLSearchParams(location.search);
  const email = urlData.get("email");
  const surveyId = urlData.get("surveyId");
  const formId = urlData.get("formId");
  const token = urlData.get("token");

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const getOrdinalSuffix = (day) => {
    if (day > 3 && day < 21) return "th"; // 11th, 12th, 13th, etc.
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  // Helper function to format the date
  const formatDate = (dateString) => {
    const date = new Date(dateString);

    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();

    const ordinalSuffix = getOrdinalSuffix(day);

    return `${day}${ordinalSuffix} ${month}, ${year}`;
  };

  return (
    <>
      <div className="premium-print-container mx-4">
        <div className="section-divider mb-3">
          <h1 className="section-title">Delivery Receipt</h1>
        </div>

        {/* file detail*/}
        <div className="data-grid mb-4">
          <div className="data-item">
            <span className="data-label">Customer</span>
            <span className="data-value">{formContent?.clientName || "-"}</span>
          </div>
          <div className="data-item">
            <span className="data-label">File Ref</span>
            <span className="data-value">{formContent?.fileRef || "-"}</span>
          </div>
          <div className="data-item">
            <span className="data-label">Organization</span>
            <span className="data-value">{formContent?.organization || "-"}</span>
          </div>
          <div className="data-item">
            <span className="data-label">Date</span>
            <span className="data-value">{formContent?.date ? formatDate(formContent?.date) : "-"}</span>
          </div>
        </div>

        {/* Shipment Details */}
        <div className="section-divider mb-2">
          <h2 className="section-title" style={{ fontSize: '11pt' }}>Shipment Details</h2>
        </div>
        <div className="data-grid mb-4">
          <div className="data-item">
            <span className="data-label">Origin Address</span>
            <span className="data-value">{formContent?.originAddress || "-"}</span>
          </div>
          <div className="data-item">
            <span className="data-label">Destination Address</span>
            <span className="data-value">{formContent?.destinationAddress || "-"}</span>
          </div>
          <div className="data-item">
            <span className="data-label">Commodity</span>
            <span className="data-value">{formContent?.commodity || "-"}</span>
          </div>
          <div className="data-item">
            <span className="data-label">No. of Packages</span>
            <span className="data-value">{formContent?.noOfPackages || "-"}</span>
          </div>
          <div className="data-item">
            <span className="data-label">Mode Of Shipment</span>
            <span className="data-value">{formContent?.modeOfShippment || "-"}</span>
          </div>
          <div className="data-item">
            <span className="data-label">Weight/Volume</span>
            <span className="data-value">{formContent?.weightVolume || "-"}</span>
          </div>
          <div className="data-item">
            <span className="data-label">Truck No.</span>
            <span className="data-value">{formContent?.truckNo || "-"}</span>
          </div>
          <div className="data-item">
            <span className="data-label">Container</span>
            <span className="data-value">{formContent?.container || "-"}</span>
          </div>
        </div>

        {/* Remarks */}
        {formContent?.remarks?.trim()?.length > 0 && (
          <div className="mb-4">
            <div className="section-divider mb-2">
              <h2 className="section-title" style={{ fontSize: '11pt' }}>Remarks</h2>
            </div>
            <p className="p-word" style={{ fontSize: '10pt', color: '#334155' }}>
              {formContent.remarks}
            </p>
          </div>
        )}

        {/* Signatures */}
        <div className="mt-5 pt-4">
          <Grid container spacing={4}>
            <Grid item xs={6} className="text-center">
              <div style={{ height: "80px", borderBottom: '1px solid #e2e8f0', marginBottom: '10px' }} className="d-flex justify-content-center align-items-center">
                {formContent.clientSign && (
                  <img src={`${Bucket}${formContent.clientSign}`} height={70} style={{ objectFit: 'contain' }} />
                )}
              </div>
              <p className="fw-bold mb-0" style={{ fontSize: '10pt' }}>Customer / Authorized Agent</p>
            </Grid>
            <Grid item xs={6} className="text-center">
              <div style={{ height: "80px", borderBottom: '1px solid #e2e8f0', marginBottom: '10px' }} className="d-flex justify-content-center align-items-center">
                {formContent?.adminSign && (
                  <img src={`${Bucket}${formContent.adminSign}`} height={70} style={{ objectFit: 'contain' }} />
                )}
              </div>
              <p className="fw-bold mb-0" style={{ fontSize: '10pt' }}>Shelozon Movers Packers & Logistics</p>
            </Grid>
          </Grid>
        </div>
      </div>

      {/* snackbar */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000} // Adjust the duration as needed
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          severity={
            snackbarMessage?.includes("successful") ? "success" : "error"
          }
          onClose={handleCloseSnackbar}
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
      {/* /snackbar */}
    </>
  );
};

export default DeliveryReceiptDownload;
